import * as React from 'react';
import LocalDiv from '../../localization/LocalDiv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { css, SerializedStyles } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';


const styles = {
  root:  css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `,
  title: css`
    text-align: start;
    margin: 0;
    color: ${COLORS.DARK_GREY};
  `,
  icon:  css`
    font-size: 22px;
    color: ${COLORS.DARK_GREY};
  `,
};

type Props = {
  title: string;
  icon?: IconProp;
  iconStyle?: SerializedStyles;
  className?: string;
};


/**
 * CardHeader: a component that renders the normal TruScore card header in the correct style etc.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const CardHeader: React.FC<Props> = props => (
  <LocalDiv css={styles.root} className={props.className}>
    <h4 css={styles.title} dir='auto'>{props.title}</h4>
    {
      props.icon && <FontAwesomeIcon icon={props.icon} css={[styles.icon, props.iconStyle]} />
    }
  </LocalDiv>
);

export default CardHeader;

